export enum UILayout {
  NAVIGATION_MENU = 'NavigationMenu',
  ALLE_SEITEN = 'AlleSeiten',
  TAB_MENU_NACH_GRUPPEN = 'TabMenuNachGruppen',
  AKKORDEON_MENU_NACH_GRUPPEN = 'AkkordeonMenuNachGruppen',
  AKKORDEON_MENU_NACH_SEITEN = 'AkkordeonMenuNachSeiten'
}
